<template>
    <div id="audio" class="section">
        <v-container>
            <h2>Audio</h2>
            <hr>
            <p class="text-xs-center mb-5">Maria's Audio</p>   
              <v-layout row wrap>
                 <v-flex xs12>
                    <AudioBlock :song="song" />
                 </v-flex>
              </v-layout>
        </v-container>
    </div>
</template>

<script>
import AudioBlock from '@/components/AudioBlock'
    export default {
      name: 'Audio',
      components: { AudioBlock },
        data: () => ({
          song: [
              {
                title: '"MATTINATA"',
                author: 'by Ruggero Leoncavallo',
                song: 'mattinata.mp3'
              },
              {
                title: '"TORNA A SURRIENTO"',
                author: 'by Ernesto de Curtis',
                song: 'torna-a-surriento.mp3'
              },
              {
                title: '"XERXES"',
                author: 'Maria Danishvar Brown',
                song: 'xerxes.mp3'
              },
              {
                title: '"CON TE PARTIRO"',
                author: 'by F. Sartori',
                song: 'con-te-partiro.mp3'
              },
              {
                title: '"AH, NON CREDEA MIRARTI"',
                author: 'La Sonnambula, V. Bellini',
                song: 'ah-non-credea-mirarti.mp3'
              },
              {
                title: '"CHI IL BEL SOGNO DI DORETTA"',
                author: 'La Rondine, G. Puccini',
                song: 'chi-Il-bel-sogno.mp3'
              },
              {
                title: '"AVE MARIA"',
                author: 'Bach/Gounod',
                song: 'ave-maria-bach-gounod.mp3'
              }                                                                                    
            ]
        })
      }
</script>

<style>
  #audio {
    margin-top: 40px;
  }
</style>

